import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  setAlerts,
  setLatestNotification,
  setFanbandsStatistics,
} from 'redux/actions';
import { useSocket } from 'hooks';
import { WS_EVENTS, ALERT_PROTO_TYPES } from 'utils/constants';
import { isEmpty } from 'utils/helpers';

const useFanbandSocket = () => {
  const dispatch = useDispatch();
  const notifications = useSelector((state) => state.notifications);

  const inAreaHandler = useCallback(
    (statistics) => {
      dispatch(setFanbandsStatistics(statistics));
    },
    [dispatch]
  );
  useSocket(WS_EVENTS.FANBAND_IN_AREA, inAreaHandler);

  const statusHandler = useCallback(
    ({ online = 0, offline = 0 }) => {
      dispatch(
        setFanbandsStatistics({ online, offline, total: online + offline })
      );
    },
    [dispatch]
  );
  useSocket(WS_EVENTS.FANBAND_STATUS, statusHandler);

  const reactHandler = useCallback(
    ({ id, type }) => {
      try {
        if (!Object.values(ALERT_PROTO_TYPES).includes(type)) {
          return;
        }

        const { results = [] } = notifications[type];

        const updateAlert = (item) => ({
          ...item,
          opened: (item?.opened || 0) + 1,
        });

        const newNotifications = results.map((item) =>
          item.id === id ? updateAlert(item) : item
        );
        dispatch(setAlerts(type, newNotifications));

        // if (latestId === id && !isEmpty(latest)) {
        //   dispatch(setLatestNotification(type, updateAlert(latest)));
        // }
      } catch (error) {
        console.log(error);
      }
    },
    [notifications, dispatch]
  );
  useSocket(WS_EVENTS.FANBAND_REACT, reactHandler);

  const answerHandler = useCallback(
    ({ id, notificationId, type, answer, userId }) => {
      try {
        const alertId = id ?? notificationId;
        const answerIndex = Number(answer);
        if (
          answer == null ||
          answer === '' ||
          !Object.values(ALERT_PROTO_TYPES).includes(type) ||
          !Number.isInteger(answerIndex) ||
          answerIndex < 0
        ) {
          return;
        }

        const { results = [] } = notifications[type];
        const { latestSurvey = {} } = notifications;

        const updateSurveryAlert = (item) => {
          if (!Array.isArray(item.surveyResponses)) {
            return item;
          }
          const createdAt = new Date().toISOString();
          const surveyResponses = item.surveyResponses.map((r, idx) =>
            idx === answerIndex
              ? { ...r, count: (Number(r.count) || 0) + 1 }
              : r
          );
          const answerItem = { userId, answer: answerIndex, createdAt };
          const alreadyAnswered =
            !isEmpty(item.surveyAnswers) &&
            userId != null &&
            item.surveyAnswers.some((ans) => ans.userId === userId);
          const surveyAnswers = alreadyAnswered
            ? item.surveyAnswers
            : (item.surveyAnswers || []).concat(answerItem);

          return {
            ...item,
            surveyResponses,
            surveyAnswers,
          };
        };

        const newNotifications = results.map((item) =>
          item.id === alertId ? updateSurveryAlert(item) : item
        );
        dispatch(setAlerts(type, newNotifications));

        if (alertId === latestSurvey.id && !isEmpty(latestSurvey)) {
          dispatch(
            setLatestNotification(type, updateSurveryAlert(latestSurvey))
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    [notifications, dispatch]
  );
  useSocket(WS_EVENTS.FANBAND_ANSWER, answerHandler);
};

export default useFanbandSocket;
